import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftMessageServer } from "namirasoft-message";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { MessageLayout } from "./MessageLayout";
import { MessageRoutes } from "./MessageRoutes";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import MessageListPage from "./pages/MessageListPage";
import MessageViewPage from "./pages/MessageViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_MESSAGE}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_MESSAGE = new EnvService("REACT_APP_BASE_URL_MESSAGE", true).getString();

            let message = new NamirasoftMessageServer(REACT_APP_BASE_URL_MESSAGE, result.account.token_manager, result.notifier.onError);

            let servers = { message };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows => (<Routes>
                        <Route path={MessageRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                        <Route path={MessageRoutes.MessageList} element={<MessageListPage {...result} servers={servers} />} />
                        <Route path={MessageRoutes.MessageView(":id")} element={<MessageViewPage {...result} servers={servers} />} />

                        {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                        <Route path="*" element={<NSNotFoundPage />} />
                    </Routes >))}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={MessageRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <MessageLayout
                {...props}
            >
                {props.children}
            </MessageLayout>
        )}
        requirement={{
            verification: {
                email: false,
                phone: false
            }
        }}
    />
}

export default Router;